// Module « plateforme » : abonnement et quotas, données personnelles, sécurité, IA et services, coûts,
// partenaires assurance, assistant documentaire et traduction d'aide (F-102, F-104 à F-117).
import type { FrontModule } from "@core/modules";
import "./plateforme.css";
import { AccountDataPage, TranslationPage } from "./account";
import { AiPage } from "./ai";
import { AccountAssistantPage, LeaseAssistantTab, OrgAssistantPage, PropertyAssistantTab, TenantAssistantSection } from "./assistant";
import { BillingPage, CheckoutPage, UsageDashboard } from "./billing";
import { ApplicationRetentionTab } from "./conservation";
import { CostsPage } from "./costs";
import { CampaignInsuranceTab, InsurancePage, PropertyInsuranceTab } from "./insurance";
import { CandidateNoticeSection, PrivacyPage, PublicNoticePage, TenantNoticeSection } from "./privacy";
import { AccountSecurityPage, OrgSecurityPage } from "./security";

export const module: FrontModule = {
  name: "plateforme",
  orgRoutes: [
    { path: "abonnement", element: <BillingPage /> },
    { path: "abonnement/paiement/:sessionId", element: <CheckoutPage /> },
    { path: "donnees-personnelles", element: <PrivacyPage /> },
    { path: "securite", element: <OrgSecurityPage /> },
    { path: "ia", element: <AiPage /> },
    { path: "couts", element: <CostsPage /> },
    { path: "assurance", element: <InsurancePage /> },
    { path: "assistant", element: <OrgAssistantPage /> },
  ],
  nav: [
    { to: "abonnement", label: "Abonnement", section: "Espace", perm: "read", order: 80, hideWhenRestricted: true },
    { to: "donnees-personnelles", label: "Données personnelles", section: "Espace", perm: "members", order: 81, hideWhenRestricted: true },
    { to: "securite", label: "Sécurité", section: "Espace", perm: "members", order: 82, hideWhenRestricted: true },
    { to: "ia", label: "IA et services", section: "Espace", perm: "members", order: 83, hideWhenRestricted: true },
    { to: "couts", label: "Coûts", section: "Espace", perm: "billing", order: 84, hideWhenRestricted: true },
    { to: "assurance", label: "Partenaires assurance", section: "Espace", perm: "read", order: 85, hideWhenRestricted: true },
    { to: "assistant", label: "Assistant", section: "Espace", perm: "read", order: 86, hideWhenRestricted: true },
  ],
  publicRoutes: [{ path: "/confidentialite/:orgId/:audience", element: <PublicNoticePage /> }],
  accountRoutes: [
    { path: "/moi/securite", element: <AccountSecurityPage /> },
    { path: "/moi/donnees", element: <AccountDataPage /> },
    { path: "/moi/assistant", element: <AccountAssistantPage /> },
    { path: "/moi/traduction", element: <TranslationPage /> },
  ],
  accountNav: [
    { to: "/moi/securite", label: "Sécurité de mon compte et sessions" },
    { to: "/moi/donnees", label: "Mes données : export, accords, effacement" },
    { to: "/moi/assistant", label: "Assistant de ma location" },
    { to: "/moi/traduction", label: "Traduction d’aide" },
  ],
  Dashboard: UsageDashboard,
  leaseTabs: [{ id: "plateforme-assistant", label: "Assistant", order: 80, Component: LeaseAssistantTab, hideWhenRestricted: true }],
  propertyTabs: [
    { id: "plateforme-assistant", label: "Assistant", order: 80, Component: PropertyAssistantTab, hideWhenRestricted: true },
    { id: "plateforme-assurance", label: "Assurance", order: 85, Component: PropertyInsuranceTab, hideWhenRestricted: true },
  ],
  campaignTabs: [{ id: "plateforme-gli", label: "Assurance loyers impayés", order: 85, Component: CampaignInsuranceTab, hideWhenRestricted: true }],
  applicationTabs: [{ id: "plateforme-conservation", label: "Conservation", order: 95, Component: ApplicationRetentionTab, hideWhenRestricted: true }],
  tenantSections: [
    { id: "plateforme-assistant", label: "Assistant", order: 80, Component: TenantAssistantSection },
    { id: "plateforme-donnees", label: "Vos données", order: 90, Component: TenantNoticeSection },
  ],
  candidateSections: [{ id: "plateforme-donnees", label: "Vos données", order: 90, Component: CandidateNoticeSection }],
};
